import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { fieldsProjectsLimitsResource } from '@atlassian/jira-router-resources-admin-pages-performance/src/services/fields-project-limits/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsPerformanceCustomFieldProjectLimitRoute } from '@atlassian/jira-router-routes-admin-pages-performance-routes/src/globalSettingsPerformanceCustomFieldProjectLimitRoute.tsx';
import { customFieldProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/custom-field/project-limit/index.tsx';

export const globalSettingsPerformanceCustomFieldProjectLimitRouteEntry = createEntry(
	globalSettingsPerformanceCustomFieldProjectLimitRoute,
	() => ({
		group: 'global-settings',

		entryPoint() {
			return customFieldProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsSystem,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			fieldsProjectsLimitsResource,
		],

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceCustomFieldProjectLimitRouteEntry.tsx',
				whichExportToUse: 'globalSettingsPerformanceCustomFieldProjectLimitRouteEntry',
			},

			enabled: true,
		},
	}),
);
